<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
      <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

      <!--  ROW    -->
      <div v-if="!loading" class="vx-row mb-1" style="max-height: 550px;overflow: scroll;">
        <div class="vx-col  w-full">
          <template
            v-for="(localization, index) in workingLocalizations" :index="index">
            <div class="vx-row" :key="index">
              <div class="vx-col mb-5 pb-4 w-full">
                <vs-divider class="my-0" position="center" color="primary">{{ getLanguageNameAndCode(localization.language_id) }}</vs-divider>
                <vs-input
                  class="w-full mb-1"
                  label="Name"
                  v-model="localization.name"
                />
                <vs-textarea
                  class="w-full mb-1"
                  label="Description"
                  v-model="localization.description"
                />

              </div>
            </div>
          </template>

        </div>
      </div>

      <div class="vx-row" v-if="isModified">
        <div class="vx-col w-full mb-2">
          <vs-button class="mx-1 w-full" @click="saveChanges">Save Changes</vs-button>
        </div>
      </div>

    </div>


</template>

<script>
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter'
  import api from '@/http/api';
  import {cyclopediaHelpers} from '@/models/helpers'

  export default {
    data() {
      return {
        loading: false,
        jsonHtml: jsonHtml,
        showNewRankDialog: false,
        helpers: cyclopediaHelpers,
        languages: [new types.Language()],
        originalLocalizations: [new types.CyclopediaLocalization()],
        workingLocalizations: [new types.CyclopediaLocalization()],
      }
    },
    props: {
      cyclopedia: {
        type: types.Cyclopedia(),
        required: true,
        default: () => {
          return new types.Cyclopedia()
        }
      },
    },
    mounted() {
      this.fetchLanguages();
    },
    computed: {
      isModified() {
        return JSON.stringify(this.workingLocalizations) !== JSON.stringify(this.originalLocalizations);
      }
    },
    methods: {
      async fetchLanguages() {
        this.loading = true;
        this.languages = await api.fetchAllLanguages();
        this.buildWorkingLocalizations();
        this.loading = false;
      },
      getLanguageNameAndCode(id) {
        try {
          const lang = this.languages.filter((l) => l.language_id === id)[0];
          return `${lang.name} (${lang.code}-${lang.country || ''})`;
        } catch (e) {
          return '?';
        }
      },
      buildWorkingLocalizations() {
        if (!this.cyclopedia) return;
        this.workingLocalizations = [];
        this.languages.forEach((lang) => {
          let localization = this.helpers.getLocalization(this.cyclopedia.localizations, lang.language_id, this.cyclopedia.id);
          if (localization.language_id === 1 && !localization.name && !localization.description) {
            localization.name = this.helpers.getPreferredName(this.cyclopedia);
            localization.description = this.helpers.getPreferredDescription(this.cyclopedia);
          }
          this.workingLocalizations.push(localization)
        });
        this.originalLocalizations = JSON.parse(JSON.stringify(this.workingLocalizations));
      },
      async saveChanges() {
        if (!this.isModified) return;
        this.loading = true;

        let localizationsToSave = [];
        this.languages.forEach((lang)=> {
          // only save if the name has changed
          const original = this.helpers.getLocalization(this.originalLocalizations, lang.language_id, this.cyclopedia.id);
          const modified = this.helpers.getLocalization(this.workingLocalizations, lang.language_id, this.cyclopedia.id);
          if (original.name !== modified.name || original.description !== modified.description) {
            localizationsToSave.push(modified);
          }
        });

        let newCyclopedia = await api.putCyclopediaLocalizations(this.cyclopedia, localizationsToSave);

        this.$emit('cyclopediaUpdated', newCyclopedia);

        this.loading = false;

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
  .fill-row-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
